import { useQuery } from '@tanstack/react-query';
import { useBusinessAccountContext } from '@/hooks/useBusinessAccountContext';
import { razorpayApi } from '@/lib/api/services/razorpay';

export function useRazorpayConnection() {
    const { selectedAccountId } = useBusinessAccountContext();

    return useQuery({
        queryKey: ['razorpay-connection', selectedAccountId],
        queryFn: async () => {
            if (!selectedAccountId) return false;
            try {
                const response = await razorpayApi.checkConnection(selectedAccountId);
                return response.connected;
            } catch (error) {
                return false;
            }
        },
        enabled: !!selectedAccountId,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
}
